import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, catchError, map, tap } from 'rxjs'
import { ReportDto } from 'src/app/models/configuration/report-dto'
import { ApplicationInsightsService } from '../application-insights/application-insights.service'
import { ConfigService } from '../config/config.service'

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  constructor(
    private http: HttpClient,
    private appInsights: ApplicationInsightsService,
    private config: ConfigService,
  ) {}

  private readonly featuresBaseUrl =
    this.config.getSettings('webApi').baseUri + 'configuration/'
  private readonly featuresUrl = this.featuresBaseUrl + 'reports'

  public getReports(): Observable<ReportDto[]> {
    const params = new HttpParams()

    const result: Observable<ReportDto[]> = this.http
      .get<any>(this.featuresUrl, { params })
      .pipe(
        map((response: any) => {
          const features = response as ReportDto[]
          return features
        }),
        tap((_) => this.appInsights.logEvent('Retrieved report configuration')),
        catchError((err) => {
          throw err
        }),
      )

    return result
  }
}
